import React from 'react'
import Navbar from '../inc/Navbar'
import Kingbed from './Kingbed'

function Bedpage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <Kingbed/>
    </div>
  )
}

export default Bedpage